<template>
  <h1>AnimatingProgressBar</h1>

  <div class="row">
    <animating-progress-bar
      :current="current"
      :total="total"
      @animation-end="triggerEvent('animationEnd')"
      @animation-start="triggerEvent('animationStart')"
    />
  </div>

  <button-container :max="total" :min="0" :value="current" @input="current = $event" />

  <event-ticks :events="events" :events-active="eventsActive" class="mt-4" />
</template>

<script>
import AnimatingProgressBar from './AnimatingProgressBar.vue';
import ButtonContainer from '../DevComponent/ButtonContainer.vue';
import EventTicks from '../DevComponent/EventTicks.vue';
import DevComponentContainer from '../DevComponent/DevComponentContainer.vue';
import EventTicksComponentMixin from '../DevComponent/EventTicksComponentMixin';

export default {
  name: 'AnimatingProgressBarDev',
  components: { EventTicks, ButtonContainer, AnimatingProgressBar },
  extends: DevComponentContainer,
  mixins: [EventTicksComponentMixin],
  data() {
    return {
      total: 100,
      current: 0,
      events: ['animationStart', 'animationEnd'],
    };
  },
};
</script>
